var _rect, _g, _g2, _g3, _path, _path2, _path3, _g4, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIglMainPageDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 437,
    height: 728,
    viewBox: "0 0 437 728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_249_7",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 322,
    width: 295,
    height: 406
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.7344,
    y: 322.962,
    width: 293.853,
    height: 405.037,
    fill: "url(#paint0_linear_249_7)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_249_7)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.502 347.054L291.107 394.347L325.816 463.567L273.649 690.843L218.501 652.518L218.502 347.054Z",
    fill: "url(#paint1_linear_249_7)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M218.5 347.055L218.501 504.021L282.625 458.64L291.105 394.348L218.5 347.055Z",
    fill: "url(#paint2_linear_249_7)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.5 347.056L145.882 394.358L111.185 463.567L163.352 690.843L218.5 652.519L218.5 347.056Z",
    fill: "url(#paint3_linear_249_7)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 347.056L145.882 394.358L111.185 463.567L163.352 690.843L218.5 652.519L218.5 347.056Z",
    fill: "url(#paint4_linear_249_7)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.651 690.843L218.501 652.519L218.501 729.166L273.651 690.843Z",
    fill: "url(#paint5_linear_249_7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.501 467.746L181.984 442.37L218.501 416.995L255.018 442.37L218.501 467.746Z",
    fill: "url(#paint6_linear_249_7)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.351 690.843L218.501 729.166L218.501 652.519L163.351 690.843Z",
    fill: "url(#paint7_linear_249_7)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.501 713.014L188.921 692.459L218.501 671.904L248.082 692.459L218.501 713.014Z",
    fill: "url(#paint8_linear_249_7)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M218.501 347.054L218.5 504.02L154.376 458.64L145.896 394.348L218.501 347.054Z",
    fill: "url(#paint9_linear_249_7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.186 463.567L145.895 394.347L154.375 458.639L111.186 463.567Z",
    fill: "url(#paint10_linear_249_7)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.501 527.544L159.07 486.246L218.501 444.948L277.933 486.246L218.501 527.544Z",
    fill: "url(#paint11_linear_249_7)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.501 527.544L159.07 486.246L218.501 444.948L277.933 486.246L218.501 527.544Z",
    fill: "url(#paint12_linear_249_7)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.502 444.949L159.072 486.245L181.986 442.368L218.502 416.994L218.502 444.949Z",
    fill: "url(#paint13_linear_249_7)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.502 444.938L277.932 486.235L248.08 692.459L218.501 671.903L218.502 444.938Z",
    fill: "url(#paint14_linear_249_7)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.501 444.938L159.071 486.235L188.923 692.459L218.501 671.903L218.501 444.938Z",
    fill: "url(#paint15_linear_249_7)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.502 444.949L277.932 486.245L255.018 442.368L218.502 416.994L218.502 444.949Z",
    fill: "url(#paint16_linear_249_7)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.815 463.567L291.106 394.348L282.625 458.64L325.815 463.567Z",
    fill: "url(#paint17_linear_249_7)",
    fillOpacity: 0.7
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_249_7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.5,
    cy: 385.827,
    rx: 202.5,
    ry: 106.258,
    fill: "url(#paint18_radial_249_7)",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_249_7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.5,
    cy: 385.826,
    rx: 143.838,
    ry: 75.4762,
    fill: "url(#paint19_radial_249_7)",
    fillOpacity: 0.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 298.298L323.897 371.538L218.499 444.778L113.1 371.538L218.499 298.298Z",
    fill: "url(#paint20_linear_249_7)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.498 396.083L145.893 348.79L111.184 279.571L163.351 52.2944L218.499 90.6189L218.498 396.083Z",
    fill: "url(#paint21_linear_249_7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M218.5 396.083L218.499 239.117L154.374 284.498L145.894 348.79L218.5 396.083Z",
    fill: "url(#paint22_linear_249_7)",
    fillOpacity: 0.7
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.5 396.081L291.117 348.78L325.814 279.571L273.647 52.2944L218.5 90.6189L218.5 396.081Z",
    fill: "url(#paint23_linear_249_7)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 396.081L291.117 348.78L325.814 279.571L273.647 52.2944L218.5 90.6189L218.5 396.081Z",
    fill: "url(#paint24_linear_249_7)",
    fillOpacity: 0.5
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.349 52.2943L218.499 90.6178L218.499 13.9707L163.349 52.2943Z",
    fill: "url(#paint25_linear_249_7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 275.392L255.016 300.767L218.499 326.142L181.981 300.767L218.499 275.392Z",
    fill: "url(#paint26_linear_249_7)",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M273.649 52.2943L218.499 13.9707L218.499 90.6178L273.649 52.2943Z",
    fill: "url(#paint27_linear_249_7)",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 30.1233L248.079 50.6785L218.499 71.2336L188.918 50.6785L218.499 30.1233Z",
    fill: "url(#paint28_linear_249_7)",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M218.5 396.083L218.501 239.117L282.625 284.497L291.105 348.789L218.5 396.083Z",
    fill: "url(#paint29_linear_249_7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M325.815 279.57L291.106 348.79L282.625 284.498L325.815 279.57Z",
    fill: "url(#paint30_linear_249_7)",
    fillOpacity: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 215.593L277.93 256.891L218.499 298.189L159.067 256.891L218.499 215.593Z",
    fill: "url(#paint31_linear_249_7)",
    fillOpacity: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 215.593L277.93 256.891L218.499 298.189L159.067 256.891L218.499 215.593Z",
    fill: "url(#paint32_linear_249_7)",
    fillOpacity: 0.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.498 298.188L277.928 256.892L255.014 300.769L218.498 326.142V298.188Z",
    fill: "url(#paint33_linear_249_7)",
    fillOpacity: 0.9
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M218.498 298.199L159.068 256.902L188.92 50.6782L218.499 71.2339L218.498 298.199Z",
    fill: "url(#paint34_linear_249_7)",
    fillOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 298.199L277.929 256.902L248.077 50.6782L218.499 71.2339L218.499 298.199Z",
    fill: "url(#paint35_linear_249_7)",
    fillOpacity: 0.9
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M218.498 298.188L159.068 256.892L181.982 300.769L218.498 326.142V298.188Z",
    fill: "url(#paint36_linear_249_7)",
    fillOpacity: 0.9
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.186 279.57L145.895 348.79L154.375 284.498L111.186 279.57Z",
    fill: "url(#paint37_linear_249_7)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_249_7",
    x: 0.472682,
    y: 264.042,
    width: 436.055,
    height: 243.571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.76366,
    result: "effect1_foregroundBlur_249_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_249_7",
    x: 59.1353,
    y: 294.823,
    width: 318.73,
    height: 182.007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.76366,
    result: "effect1_foregroundBlur_249_7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_249_7",
    x1: 210.661,
    y1: 162.972,
    x2: 210.661,
    y2: 600.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_249_7",
    x1: 7.27051,
    y1: 714.896,
    x2: -15.0235,
    y2: 458.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D79ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#3458C1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618879,
    stopColor: "#3753B8",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#5BB0FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB0FF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_249_7",
    x1: 227.087,
    y1: 367.769,
    x2: 277.25,
    y2: 460.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#DFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#0E42C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_249_7",
    x1: 111.186,
    y1: 337.584,
    x2: 251.337,
    y2: 426.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.280479,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469567,
    stopColor: "#FF79DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#3D3AE3",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_249_7",
    x1: 111.186,
    y1: 353.515,
    x2: 255.302,
    y2: 468.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_249_7",
    x1: 218.365,
    y1: 727.892,
    x2: 255.681,
    y2: 677.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#496BE4",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3CA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_249_7",
    x1: 197.542,
    y1: 428.056,
    x2: 248.63,
    y2: 438.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_249_7",
    x1: 163.35,
    y1: 694.773,
    x2: 216.061,
    y2: 698.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF79C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3CA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_249_7",
    x1: 194.638,
    y1: 687.645,
    x2: 229.67,
    y2: 690.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52FF6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_249_7",
    x1: 160.096,
    y1: 371.961,
    x2: 198.065,
    y2: 484.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103809,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436548,
    stopColor: "#FFAACE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#6F97FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_249_7",
    x1: 132.781,
    y1: 412.207,
    x2: 161.377,
    y2: 459.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591466,
    stopColor: "#FF94D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C994FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_249_7",
    x1: 184.39,
    y1: 462.949,
    x2: 267.535,
    y2: 479.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_249_7",
    x1: 218.501,
    y1: 447.913,
    x2: 218.501,
    y2: 529.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_249_7",
    x1: 156.173,
    y1: 486.245,
    x2: 226.736,
    y2: 433.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149863,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300261,
    stopColor: "#8CFF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449118,
    stopColor: "#45C3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72E6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_249_7",
    x1: 245.036,
    y1: 444.938,
    x2: 349.923,
    y2: 506.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_249_7",
    x1: 10.8049,
    y1: 537.737,
    x2: 128.132,
    y2: 639.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.464598,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.790313,
    stopColor: "#6DF390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21CAFF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_249_7",
    x1: 277.932,
    y1: 486.245,
    x2: 210.161,
    y2: 432.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297772,
    stopColor: "#8CFF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#5BF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_249_7",
    x1: 288.846,
    y1: 388.73,
    x2: 300.841,
    y2: 462.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#0E42C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_249_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.5 385.827) rotate(90) scale(106.258 202.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6978FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_249_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.5 385.826) rotate(90) scale(75.4762 143.838)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6978FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_249_7",
    x1: 271.198,
    y1: 308.218,
    x2: 146.663,
    y2: 411.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_249_7",
    x1: 429.729,
    y1: 28.2412,
    x2: 452.024,
    y2: 284.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D79ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#3458C1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618879,
    stopColor: "#3753B8",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#5BB0FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB0FF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_249_7",
    x1: 209.912,
    y1: 375.369,
    x2: 159.749,
    y2: 282.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#DFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#0E42C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_249_7",
    x1: 325.814,
    y1: 405.553,
    x2: 185.662,
    y2: 316.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.280479,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469567,
    stopColor: "#FF79DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#3D3AE3",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_249_7",
    x1: 325.814,
    y1: 389.622,
    x2: 181.698,
    y2: 274.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_249_7",
    x1: 218.635,
    y1: 15.2448,
    x2: 181.319,
    y2: 66.1334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#496BE4",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3CA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_249_7",
    x1: 239.458,
    y1: 315.082,
    x2: 188.37,
    y2: 305.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_249_7",
    x1: 273.65,
    y1: 48.3644,
    x2: 220.939,
    y2: 44.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF79C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3CA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_249_7",
    x1: 242.362,
    y1: 55.4922,
    x2: 207.33,
    y2: 52.1444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52FF6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_249_7",
    x1: 276.905,
    y1: 371.176,
    x2: 238.936,
    y2: 259.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103809,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436548,
    stopColor: "#FFAACE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#6F97FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_249_7",
    x1: 304.22,
    y1: 330.93,
    x2: 275.624,
    y2: 283.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591466,
    stopColor: "#FF94D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C994FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_249_7",
    x1: 252.61,
    y1: 280.188,
    x2: 169.465,
    y2: 263.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_249_7",
    x1: 218.499,
    y1: 295.224,
    x2: 218.499,
    y2: 213.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_249_7",
    x1: 280.827,
    y1: 256.892,
    x2: 210.264,
    y2: 309.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149863,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300261,
    stopColor: "#8CFF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449118,
    stopColor: "#45C3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72E6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_249_7",
    x1: 191.964,
    y1: 298.199,
    x2: 87.077,
    y2: 237.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_249_7",
    x1: 426.195,
    y1: 205.4,
    x2: 308.868,
    y2: 103.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.464598,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.790313,
    stopColor: "#6DF390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21CAFF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_249_7",
    x1: 159.068,
    y1: 256.892,
    x2: 226.839,
    y2: 310.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297772,
    stopColor: "#8CFF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#5BF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_249_7",
    x1: 148.154,
    y1: 354.407,
    x2: 136.16,
    y2: 280.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#0E42C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIglMainPageDiamond);
export default __webpack_public_path__ + "static/media/igl_main_page_diamond.cc0462a6dd1e74ee2d3e57c9832bf25f.svg";
export { ForwardRef as ReactComponent };